module.exports = __webpack_public_path__ + "static/media/empty-feed.3591ef78.png";